import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap"
import styles from "./style.module.css"
import { DateRangePicker } from "rsuite"
import { format } from "date-fns"
import axiosService from "../../utils/axios.service";
import _ from "lodash"
import { Spin, Select, message, Table, Pagination, Input } from "antd"
import StorageService from "../../utils/storage.service";
import "./scss/report.scss"

const ReportOrderMisa = () => {
    const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    
    const [listStore, setListStore] = useState([])
    const [storeId, setStoreId] = useState({value: StorageService.getItem("currentStore"), label: StorageService.getItem("currentNameStore")})

    const [loading, setLoading] = useState(true);
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [list, setList] = useState([])
    const [type, setType] = useState({value: 0, label: "Tất cả"})
    const [orderId, setOrderId] = useState('')

    const listType = [
        {value: 0, label: "Tất cả"},
        {value: 1, label: "Đã xuất hóa đơn"},
        {value: 2, label: "Chưa xuất hóa đơn"}
    ]

    const columns = [
        {
            title: 'Trạng thái',
            key: 'status_order_misa',
            align: "center",
            render: (data) => {
                return (
                    <div className="value">
                        {data.guid ? 
                            data.misa_no ? 
                                <span className="misa-success">{data.misa_no}</span> 
                            :
                                <span className="misa-pending">Đã xuất HĐ</span> 
                        : 
                            <span className="qr-cancel">Chưa xuất HĐ</span>
                        }
                    </div>
                )
            },
        },
        {
            title: 'Mã đơn hàng',
            key: "order_code",
            align: "center",
            render: (data) => {
                return (
                    <>
                        {data.order.order_code} <br/>
                        {format(new Date(data.order.order_at), "dd-MM-yyyy HH:mm")}
                    </>
                )
            },
        },
        {
            title: 'Mã giao dịch',
            key: 'transaction_code',
            align: "center",
            render: (data) => {
                return (    
                    <>
                        {data.transaction_code} <br/>
                        {format(new Date(data.transaction_at), "dd-MM-yyyy HH:mm")}
                    </>
                )
            },
        },
        {
            title: 'Khách hàng',
            key: 'customer',
            align: "center",
            render: (data) => {
                return (
                    <div className="value">
                        {data.order.customers.mobile}<br/>{data.order.customers.full_name}
                    </div>
                )
            },
        },
        {
            title: 'Số tiền',
            key: "amount",
            align: "center",
            render: (data) => {
                return (
                    <>
                        {convertCurrency(data.paid_amount - (data.using_switch_deposit_money ?? 0))}
                    </>
                )
            },
        },
        {
            title: 'Phương thức',
            key: "pay_type",
            dataIndex: 'pay_type',
            align: "center",
            render: (data) => {
                return (
                    <div className="value">{data}</div>
                )
            },
        },

        {
            title: 'STK',
            key: "pay_account_number",
            dataIndex: 'pay_account_number',
            align: "center",
            render: (data) => {
                let dataAccount = data?.split(" - ")
                return (
                    dataAccount?.length > 0 ?
                        <div className="value">
                            {dataAccount[0]}<br/>
                            {dataAccount[2]}
                        </div>
                    :null
                )
            },
        },
        {
            title: 'Cơ sở bán',
            key: "store_buy",
            align: "center",
            render: (data) => {
                return (
                    <div className="value">{data.order.stores.name_store}</div>
                )
            },
        },
                {
            title: 'Cơ sở thu tiền',
            key: "store_paid",
            align: "center",
            render: (data) => {
                return (
                    <div className="value">{data.store.name_store}</div>
                )
            },
        }
    ];

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    useEffect(async () => {
        fetchData(1, 10)
        getListStore()
    }, [])

    const getListStore = async () => {
        let response = await axiosService("api/stores", "GET");
        const selectDataStore = [{value: 0, label: "Tất cả"}]
        if (response.data.code == 200) {
            if (response.data.data !== null) {
                for (const key in response.data.data) {
                    selectDataStore.push({
                        value: response.data.data[key].id,
                        label: response.data.data[key].name_store
                    })
                }

                setListStore(selectDataStore)
            }
        }
    }

    const fetchData = async (current_page = null, current_limit = null) => {
        try {
            let payload = {
                limit: current_limit ?? limit,
                page: current_page ?? page,
                storeId: storeId.value,
                startDate: format(new Date(startDate), 'yyyy-MM-dd'),
                endDate: format(new Date(endDate), 'yyyy-MM-dd'),
                type: type.value,
                orderId: orderId,
                status: 1
            }
            const res = await axiosService(`api/transaction/get-order-misa`, "POST", payload);
            if (res.data.success) {
                const { data } = res.data
                setList(data.results)
                setTotal(data.pagination.total)
            } else {
                message.error("Có lỗi xảy ra")
            }
        } catch (error) {
            console.error(error)
            message.error("Có lỗi xảy ra")
        }
        setLoading(false)
    }

    const onChangeType = async (value) => {
        setType(value);
    }

    const onChangeStore = (value) => {
        setStoreId(value);
    };

    const onChangeDate = (value) => {
        setStartDate(value[0])
        setEndDate(value[1])
    };

    const onChangeOrderId = (value) => {
        setOrderId(value.target.value)
    }

    const searchData = () => {
        setPage(1)
        setLoading(true)
        fetchData(1, limit)
    }

    const handleChangePage = (page, pageSize) => {
        setPage(page)
        setLimit(pageSize)

        setLoading(true)
        fetchData(page, pageSize)
    }

    const exportData = async () => {
        setLoading(true)
        try {
            let payload = {
                storeId: storeId.value,
                startDate: format(new Date(startDate), 'yyyy-MM-dd'),
                endDate: format(new Date(endDate), 'yyyy-MM-dd'),
                type: type.value,
                orderId: orderId,
                status: 2
            }
            const res = await axiosService(`api/transaction/get-order-misa`, "POST", payload);

            if (res.data.success) {
                window.location.href = res.data.data.results
            } else {
                message.error("Có lỗi xảy ra")
            }
        } catch (error) {
            console.error(error)
            message.error("Có lỗi xảy ra")
        }
        setLoading(false)
    }

    return (
        <Spin spinning={loading}>
            <div className={`${styles.backgroundQR} container-fluid report-page report-qrcode`}>
                <Row>
                    <Col lg={12} xl={5}></Col>
                    <Col xs={6} md={4} lg={3} xl={1}>
                        Mã hoá đơn
                        <Input
                            className="w-100"
                            onChange={onChangeOrderId}
                        />
                    </Col>  
                    <Col xs={6} md={4} lg={3} xl={1}>
                        Trạng thái
                        <Select
                            className="w-100"
                            labelInValue
                            value={type}
                            defaultValue={type}
                            onChange={onChangeType}
                            options={listType}
                        />
                    </Col>  
                    <Col xs={6} md={4} lg={3} xl={1}>
                        Cơ sở
                        <Select
                            className="w-100"
                            labelInValue
                            value={storeId}
                            defaultValue={storeId}
                            onChange={onChangeStore}
                            options={listStore}
                        />
                    </Col>
                    <Col xs={6} md={4} lg={3} xl={2}>
                        Thời gian
                        <DateRangePicker
                            className="w-100"
                            placement={"bottomStart"}
                            format="yyyy-MM-dd"
                            onChange={onChangeDate}
                            showOneCalendar={true}
                            // ranges={type != 'detail-ktv-tvv' ? ranges : rangesNv}
                            defaultValue={[new Date(startDate), new Date(endDate)]}
                        />
                    </Col>
                    <Col xs={6} md={4} lg={3} xl={1}>
                        <button onClick={searchData} type="button" className="w-100 btn-primary" style={{marginTop: '22px', height: '32px', lineHeight: '32px', borderRadius: '4px'}}><i className="fa fa-filter"></i> Tìm kiếm</button>
                    </Col> 
                    <Col xs={6} md={4} lg={3} xl={1}>
                        <button onClick={exportData} type="button" className="w-100 btn-primary" style={{marginTop: '22px', height: '32px', lineHeight: '32px', borderRadius: '4px'}}>
                            <i className="fas fa-download"></i> Export
                        </button>
                    </Col>  
                </Row>
                <Row className="pt-2">
                    <Col xs={12}>
                        <div className="d-flex justify-content-end w-100 mt-2">
                            <p>Đang hiển thị <span style={{ color: "blue" }}>{list.length}</span> trên tổng số <span style={{ color: "red" }}>{total}</span> kết quả</p>
                        </div>
                        <Table
                            className="w-100 text-center"
                            pagination={false}
                            columns={columns} 
                            dataSource={list}
                            rowKey={"id"}
                        />
                        <div className={`d-flex justify-content-end w-100 mt-4 pt-2 pb-2 mr-5 ${styles.fixedPagination}`}>
                            <Pagination current={page} total={total} pageSize={limit} showSizeChanger showQuickJumper onChange={handleChangePage} />
                        </div>
                    </Col>
                </Row>
            </div>
        </Spin>
    )
}
export default ReportOrderMisa